export default "/packs/images/carabiner-3~29f3633a39acc6f0a122685058362334.png";